/* eslint dom-in-jsx/no-document-calls: 0 */
import React, { useMemo } from 'react';
import Portal from '../Portal.jsx';
import ActionDropdown from '../action_dropdown/ActionDropdown.jsx';

export default function HashActionDropdown(props) {
  const deleteConfirmation = useMemo(() => {
    if (!props.parentName || props.parentName === 0) {
      return 'The current value will be permanently removed from RPM.';
    }

    return (
      <span>
        The current value(s) for <b>{props.propertyName}</b> for{' '}
        <b>{props.resourceName}</b> will be permanently deleted. The Node keys
        will be either removed or it will inherit its Node Group value.
      </span>
    );
  }, []);
  const copyConfirmation = useMemo(() => {
    return (
      <span>
        Would you like to copy Group Hash data from {props.parentName} to{' '}
        {props.resourceName}?
        <br />
        <strong>Warning:</strong> This action will erase all existing data.
      </span>
    );
  }, []);

  const mountNode = useMemo(
    () => document.getElementsByClassName('actions io-form-actions')[0],
    [],
  );

  return (
    <Portal node={mountNode}>
      <ActionDropdown
        button
        className='actions-container'
        zIndex={2000}
      >
        <ActionDropdown.Item
          className={'Dropdown-item-delete'}
          icon='trash'
          text='Delete Value'
          value='delete'
        >
          <ActionDropdown.Confirmation
            body={{
              skip_impact: true,
              [props.resourceType]: {
                properties: { [props.templateName]: '[]' },
              },
            }}
            method={'PATCH'}
            msg={deleteConfirmation}
            path={props.path}
            title={'Delete Value'}
          />
        </ActionDropdown.Item>

        <ActionDropdown.Tooltip
          content='This variable is either not enabled or does not have data at the Node Group level.'
          hidden={props.hasParentValue}
        >
          <ActionDropdown.Item
            className={'Dropdown-item-copyFromParent'}
            disabled={!props.hasParentValue}
            icon={'copy'}
            text={'Copy From Node Group'}
            value='copyFromParent'
          >
            <ActionDropdown.Confirmation
              customConfirmationHandler={props.handleCopy}
              msg={copyConfirmation}
              title={'Copy From Node Group'}
            />
          </ActionDropdown.Item>
        </ActionDropdown.Tooltip>
      </ActionDropdown>
    </Portal>
  );
}
